var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ChipMUI from '@mui/material/Chip';
import React from 'react';
export const ChipV2 = React.forwardRef((props, ref) => {
    const { classes } = props, rest = __rest(props, ["classes"]);
    return React.createElement(ChipMUI, Object.assign({ size: "small", "data-cy": "chip" }, rest, { ref: ref }));
});
